<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <div class="d-flex">
            Xin vui lòng điền tiền tố:
            <v-text-field
              class="mx-2"
              v-model="prefix"
              label="Tiền tố"
              :rules="[rules.required, rules.prefixLength]"
              dense
              outlined
            ></v-text-field>
          </div>
          <span>
            <span style="color: red"
              ><i><strong>(*) Lưu ý:</strong></i></span
            >
            Tiền tố phải có đủ 3 ký tự.
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="openConfirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeConfirm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            Thao tác này sẽ đánh số báo danh cho các học sinh chưa có số báo danh cho kỳ kiểm tra này.<br />
            Bạn có chắc là bạn muốn thực hiện thao tác không?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="closeConfirm" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StudentExam } from '../../plugins/api'
export default {
  props: {
    exam: String,
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      prefix: '',
      rules: {
        required: value => !!value || 'Phải nhập tiền tố',
        prefixLength: value => value.length === 3 || 'Tiền tố phải có đủ 3 ký tự.'
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    openConfirm() {
      this.confirmDialog = true
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    async confirm() {
      this.$loading.active = true
      const indexing = await StudentExam.indexingEmpty({ exam: this.exam, prefix: this.prefix })
      if (indexing === 'finish') {
        this.$alert.success('Đánh số báo danh thành công')
        this.$emit('refresh')
        this.closeConfirm()
        this.cancel()
      } else {
        this.$alert.error('Lỗi đánh số báo danh')
        this.closeConfirm()
      }
      this.$loading.active = false
    }
  }
}
</script>
